module.exports = __webpack_public_path__ + "static/media/campaign1.0b80749f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/campaign1.png
// module id = 2226
// module chunks = 0